import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getToken: params => `${baseURL}/api/token?${encodeParams(params)}`,
    getMessage: (idList, idMessage) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/messages/${encodeURIComponent(idMessage)}`,
    deleteTemplate: (idList, externalId) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/templates/${encodeURIComponent(externalId)}`,
    copyTemplate: (idList, externalId) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/templates/${encodeURIComponent(externalId)}/copy`
  }
})(process.env.BERCS_URL)

export const beRcsCopyTemplate = (idList, externalId) => {
  const url = endpoints.copyTemplate(idList, externalId)
  return apiWrapper({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsDeleteTemplate = (idList, externalId) => {
  const url = endpoints.deleteTemplate(idList, externalId)
  return apiWrapper({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsGetMessage = (idList, idMessage) => {
  const url = endpoints.getMessage(idList, idMessage)
  return apiWrapper({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsGetToken = idList => {
  const url = endpoints.getToken({ idList: idList })
  return apiWrapper({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const BERCS_SENDING_STATE_TOECEXUTE = 'ToExecute'
export const BERCS_SENDING_STATE_CANCELLED = 'Cancelled' // forse non necessario
export const BERCS_SENDING_STATE_RUNNING = 'Running'
export const BERCS_SENDING_STATE_COMPLETED = 'Completed'
export const BERCS_SENDING_STATE_FALIED = 'Failed'
export const BERCS_SENDING_STATE_DISCARTED = 'Discarded' // forse non necessario
export const BERCS_SENDING_STATE_RETRIED = 'Retried' // forse non necessario
export const BERCS_SENDING_STATE_UPDATING = 'Updating' // forse non necessario

export const RCS_QUEUING_RUNNING = 'Running'
export const RCS_QUEUING_COMPLETED = 'Completed'
export const RCS_QUEUING_FAILED = 'Failed'
export const RCS_QUEUING_NEUTRAL = 'Neutral'
